import AxiosInstance from '../config/AxiosInstance';

export interface Product {
    id: string;
    sku: string;
    type: number;
    productName: string;
    productGroup: { groupName: string };
    updatedAt: Date;
    isActive: boolean;
}

export interface ProductAttributesPayload {
    productId: string;
    position: number;
}
export interface Location {
    id: string;
}

export interface DeviceUserPayload {
    companyId: string;
    firstName: string;
    lastName: string;
    loginId: string;
    loginPin: string;
    nfcCode: string;
    emailAddress: string;
    deviceUserRoleId: string;
    employeeId?: string;
    statusId: number;
    location: Location[];
}

export interface EmployeePayload {
    page: number,
    limit: number,
    searchValue: string,
    sort: "DESC"
}

const createDeviceUser = async (payload: DeviceUserPayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/device-user', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}


const getListDeviceUserRole = async (page: number, limit: number, companyId: string, searchValue: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/device-user-role/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListEmployees = async (payload: EmployeePayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/employees/list', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}


const getDetailDeviceUser = async (id: string, companyId: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/device-user/find-one/${id}`);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateDeviceUser = async (id: string, payload: DeviceUserPayload) => {
    try {
        const { data } = await AxiosInstance.put('/api/device-user/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListDeviceUser = async (companyId: string, page: number, limit: number, searchValue: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/device-user/list', {
            params: {
                page: page,
                limit: limit,
                companyId: companyId,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteDeviceUser = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/device-user/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    createDeviceUser,
    getListDeviceUserRole,
    getListEmployees,
    updateDeviceUser,
    getListDeviceUser,
    deleteDeviceUser,
    getDetailDeviceUser
}